"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = __importStar(require("react"));
var clsx_1 = __importDefault(require("clsx"));
var useEditableField_1 = require("@features/ItemCommon/hooks/useEditableField");
var ConfirmRevertButtons_1 = __importDefault(require("@components/ConfirmRevertButtons"));
var EditInput_1 = require("@features/ItemCommon/components/common/JobField/EditInput");
var clickOutsideHook_1 = require("@common/hooks/clickOutsideHook");
var linkUtils_1 = require("@utils/linkUtils");
var ExternalLink_1 = __importDefault(require("@components/ExternalLink"));
var QuickActions_1 = __importDefault(require("@features/ItemCommon/components/common/JobField/QuickActions"));
var formatter_1 = require("@utils/formatter");
var overflow_1 = require("@utils/overflow");
var isReadOnlyField = function (value) {
    return typeof value === 'object' || value === 'null' || value === null || value === 'undefined' || Array.isArray(value);
};
var guessInputType = function (value) {
    if (value === 'true' || value === 'false' || value === true || value === false) {
        return 'boolean';
    }
    if (typeof value === 'string') {
        return 'text';
    }
    if (!Number.isNaN(value)) {
        return 'number';
    }
    if (isReadOnlyField(value)) {
        return '';
    }
    return 'text';
};
function JobField(_a) {
    var cyName = _a.cyName, domain = _a.domain, label = _a.label, placeholderText = _a.placeholderText, isNotEditable = _a.isNotEditable, value = _a.value, title = _a.title, setValue = _a.setValue, tooltipText = _a.tooltipText, minVal = _a.minVal, automationListsPermission = _a.automationListsPermission, _b = _a.showQuickAddToList, showQuickAddToList = _b === void 0 ? true : _b, _c = _a.showCopyIcon, showCopyIcon = _c === void 0 ? true : _c, _d = _a.labelClassName, labelClassName = _d === void 0 ? 'item-detail-field__label' : _d, _e = _a.renderLinks, renderLinks = _e === void 0 ? true : _e, _f = _a.formatNumber, formatNumber = _f === void 0 ? false : _f;
    var textAreaRef = (0, react_1.useRef)(null);
    var containerRef = (0, react_1.useRef)(null);
    var textRef = (0, react_1.useRef)(null);
    var _g = (0, useEditableField_1.useEditableField)(value, isNotEditable, setValue, textAreaRef), mode = _g.mode, handleClick = _g.handleClick, onClickOutside = _g.onClickOutside, handleKeyDown = _g.handleKeyDown, resetToOriginalValue = _g.resetToOriginalValue, confirmChanges = _g.confirmChanges, tempValue = _g.tempValue, setTempValue = _g.setTempValue;
    (0, clickOutsideHook_1.useClickOutside)(containerRef, onClickOutside, [tempValue]);
    var _h = (0, react_1.useMemo)(function () {
        var isReadOnly = isReadOnlyField(value);
        return { isReadOnly: isReadOnly, fieldType: guessInputType(value) };
    }, [value]), fieldType = _h.fieldType, isReadOnly = _h.isReadOnly;
    var stringValue = String(value);
    var isUrl = (0, react_1.useMemo)(function () {
        return renderLinks && (0, linkUtils_1.shouldBeRenderedAsLink)(stringValue);
    }, [value]);
    var classes = (0, clsx_1.default)({
        'item-detail-field': isNotEditable || isReadOnly,
        'item-detail-field-edit': !isNotEditable && !isReadOnly,
    });
    var getStringValue = function (value) {
        if (value === undefined || value === null || Number.isNaN(value)) {
            return '';
        }
        // if it's a number, format it
        if (formatNumber && typeof value === 'number') {
            return (0, formatter_1.thousandSeparator)(value);
        }
        return typeof value === 'string' ? value : JSON.stringify(value);
    };
    return (react_1.default.createElement("div", { className: classes, "data-cy": "job-field-".concat(cyName || label) },
        react_1.default.createElement("span", { className: labelClassName, title: label }, label),
        mode === 'VIEW' && (react_1.default.createElement(react_1.default.Fragment, null,
            isUrl ? (react_1.default.createElement("div", { className: (0, clsx_1.default)('item-detail-field-value-container', { 'item-detail-field-clickable': !isReadOnly }), onClick: function () {
                    if (!isReadOnly) {
                        handleClick();
                    }
                } },
                react_1.default.createElement(ExternalLink_1.default, { href: stringValue, domain: domain, "data-cy": "job-field-".concat(cyName || label, "-value"), classOverride: "item-detail-field__value-link" }, stringValue),
                react_1.default.createElement(QuickActions_1.default, { showCopyIcon: showCopyIcon, showQuickAddToList: showQuickAddToList, isNotEditable: isNotEditable, isReadOnlyField: isReadOnlyField(value), domain: domain, label: label, value: value, automationListsPermission: automationListsPermission }))) : (react_1.default.createElement("div", { "data-cy": "job-field-".concat(cyName || label, "-value"), ref: textRef, className: (0, clsx_1.default)({
                    'item-detail-field-value-container': !tooltipText,
                    'item-detail-field-value-container-with-tooltip': tooltipText,
                    'item-detail-field__value--disabled': true,
                    'eva-tooltip-container': tooltipText,
                }), title: !tooltipText && (0, overflow_1.isTextOverflowing)(textRef.current) ? title || stringValue : undefined, onClick: function () {
                    if (!isReadOnly) {
                        handleClick();
                    }
                } },
                getStringValue(value),
                tooltipText && react_1.default.createElement("span", { className: "eva-tooltip" }, tooltipText))),
            react_1.default.createElement(QuickActions_1.default, { showCopyIcon: showCopyIcon, showQuickAddToList: showQuickAddToList, isNotEditable: isNotEditable, isReadOnlyField: isReadOnlyField(value), domain: domain, label: label, value: value, automationListsPermission: automationListsPermission }))),
        mode === 'EDIT' && (react_1.default.createElement("div", { className: "edit-input", ref: containerRef },
            react_1.default.createElement(EditInput_1.EditInput, { cyName: cyName, inputType: fieldType, placeholderText: placeholderText, tempValue: tempValue, setTempValue: setTempValue, handleKeyDown: handleKeyDown, label: label, textAreaRef: textAreaRef, minVal: minVal }),
            react_1.default.createElement(ConfirmRevertButtons_1.default, { name: "job-field-".concat(cyName || label, "-button"), onConfirmClicked: function () { return confirmChanges(tempValue || ''); }, onRevertClicked: resetToOriginalValue })))));
}
exports.default = JobField;
